import Text from 'antd/es/typography/Text';
import { styled } from '@mui/material/styles';

const ImageMarked = styled('span')(({ theme }) => ({
  position: 'absolute',
  bottom: '5%',
  borderBottom: '3px solid #F56626',
}));

function getMarkedStyle(text) {
  if (text.includes('China Quiz')) {
    return {
      width: `calc(${text.length}*2%)`,
      left: `calc(${text.length}*4%)`,
    };
  } else if (text.includes('Hanzi Game')) { 
    return {
      width: `calc(${text.length}*1.5%)`,
      left: `calc(${text.length}*4.25%)`,
    };
  } else if (text.includes('Hanzi Level')) { 
    return {
      width: `calc(${text.length}*1%)`,
      left: `calc(${text.length}*3%)`,
    };
  } else if (text.includes('Question')) { 
    return {
      width: '20%',
      left: '40%',
    };
  } else {
    return {
      width: '8%',
      left: '47%',
    };
  }
}

export default function(props) {
	const {
		text,
	} = props;
	const markedStyle = getMarkedStyle(text);

	return (
		<Text style={{ fontFamily: 'AvenirNextLTPro-Bold', fontSize: '5em' }}>
      <span style={{ color: '#FF5A00' }}>
        {
          text.split(' ')
          .slice(0, text.split(' ').length/2)
          .map(word => <>{word}&nbsp;</>)
        }
      </span>
      <span style={{ color: 'black' }}>
        {
          text.split(' ')
          .slice(text.split(' ').length/2)
          .map(word => <>{word}&nbsp;</>)
        }
      </span>
      <ImageMarked style={markedStyle} />
    </Text>
	)
}